import { SubscriptionPlan } from '@app/domain/SubscriptionPlan';
import { httpApi } from './http.api';

export const fetchPlans = (): Promise<SubscriptionPlan[]> =>
  httpApi.get<SubscriptionPlan[]>('plans').then(({ data }) => data);

export const subscribePlan = (planCode: number): Promise<SubscriptionPlan[]> =>
  httpApi.get<SubscriptionPlan[]>(`plans/subscribe/${planCode}`).then(({ data }) => data);
